// angular dependencies
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCard, MatCardActions } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

// fantaz dependencies
import { EventParticipant, NextEvent } from '@fantaz/shared/data-access/models';
import { ProcessingDirective } from '@fantaz/shared/directives/processing';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { CurrencyPipe } from '@fantaz/shared/ui/currency';
import { EventNumber } from './event-number/event-number';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';

@Component({
  selector: 'fz-play-event-card',
  standalone: true,
  imports: [
    CommonModule,
    MatCard,
    MatCardActions,
    MatDivider,
    MatButtonToggleModule,
    MatButton,
    MatIconModule,
    SharedPipesDateModule,
    ProcessingDirective,
    LeaderboardComponent,
    CurrencyPipe,
    EventNumber,
  ],
  templateUrl: './play-event-card.component.html',
  styleUrl: './play-event-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {},
})
export class PlayEventCardComponent {
  @Input() enabled = false;
  @Input() next = false;
  @Input() isPlayStarting = false;

  @Input() eventCode: string | undefined;

  @Input() event: NextEvent;

  @Input() seats: number;

  @Input() ended: boolean;

  @Input() seatsAvailable: number;

  @Input() participants: EventParticipant[];

  @Output() playPress = new EventEmitter<void>();

  viewMode = signal<'overview' | 'leaderboard'>('overview');

  onViewModeChange(value: 'overview' | 'leaderboard') {
    this.viewMode.set(value);
  }

  handlePlayPress() {
    this.playPress.emit();
  }
}
